import { render, staticRenderFns } from "./SCard.vue?vue&type=template&id=2fa5c808&lang=pug"
import script from "./SCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports